/* tslint:disable */
/* eslint-disable */
export enum DeletedItemsInclusionEnum {
  Exclusive = 'Exclusive',
  Inclusive = 'Inclusive',
  Remove = 'Remove'
}
